export enum PropertyOnboardingType {
  NewProperty = 'new',
}
